<template>
  <div>
    <div style="padding: 15px 30px" class="light_blue_holder">
      <div class="flex flex-wrap justify-between items-center mb-4">
        <h4>Notes</h4>
        <div class="inline-flex">
          <strong class="pr-2">Private</strong>
          <vs-switch v-model="createPayload.is_private" />
        </div>
      </div>
      <template  v-if="!createPayload.is_private">
        <div class="flex flex-wrap justify-between items-center mb-4"
        >
          <div class="md:w-1/3 w-full my-2">
            <div class="px-2">
              <vs-checkbox class="mb-2" v-model="studentsChecked">Students</vs-checkbox>
            </div>
          </div>


          <div class="md:w-1/3 w-full my-2">
            <div class="px-2">
              <vs-checkbox class="mb-2" v-model="parentsChecked">Parents</vs-checkbox>
            </div>
          </div>
          <div class="md:w-1/3 w-full my-2">
            <div class="px-2">
              <vs-checkbox class="mb-2" v-model="staffChecked">Staffs</vs-checkbox>
             
            </div>
          </div>
        </div>
        <div class="inline-flex w-full py-2" v-if="studentsChecked">
          <label style="min-width: 100px">Students</label>
          <v-select
                  :getOptionLabel="
                    (item) => `${item.first_name} ${item.last_name}`
                  "
                  class="bg_white w-full"
                  placeholder="Students"
                  v-model="selectedStudent"
                  :options="studentlist"
                  label="name"
                  @open="onOpenStudent"
                  @close="onCloseStudent"
                  multiple
                >
                  <template v-slot:selected-option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.first_name }}
                    {{ studentlist.last_name }}
                  </template>
                  <template v-slot:option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.first_name }}
                    {{ studentlist.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadStudent"
                      class="loader"
                      v-show="student_meta.has_next"
                    >
                      Loading more students...
                    </li>
                  </template>
          </v-select>
        </div>
        <div class="inline-flex w-full py-2" v-if="parentsChecked">
            <label style="min-width: 100px">Parents</label>
            <v-select
              :getOptionLabel="
                (item) => `${item.first_name} ${item.last_name}`
              "
              class="bg_white w-full"
              placeholder="Parents"
              v-model="selectedParent"
              :options="parentlist"
              label="name"
              @open="onOpenParent"
              @close="onCloseParent"
              multiple
            >
              <template v-slot:selected-option="parentlist">
                <img
                  v-if="parentlist.picture"
                  class="person-img rounded-full"
                  :src="parentlist.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ parentlist.first_name }}
                {{ parentlist.last_name }}
              </template>
              <template v-slot:option="parentlist">
                <img
                  v-if="parentlist.picture"
                  class="person-img rounded-full"
                  :src="parentlist.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                {{ parentlist.first_name }}
                {{ parentlist.last_name }}
              </template>
              <template #list-footer>
                <li
                  ref="loadParent"
                  class="loader"
                  v-show="parent_meta.has_next"
                >
                  Loading more parents...
                </li>
              </template>
            </v-select>
        </div>
        <div class="inline-flex w-full py-2" v-if="staffChecked">
              <label style="min-width: 100px">Staffs</label>
                  <v-select
                    :getOptionLabel="
                      (item) => `${item.first_name} ${item.last_name}`
                    "
                    class="bg_white w-full"
                    placeholder="Staffs"
                    v-model="selectedStaff"
                    :options="teacherList"
                  
                    label="name"
                    @open="onOpenTeacher"
                    @close="onCloseTeacher"
                    multiple
                  >
                    <template v-slot:selected-option="teacherList">
                      <img
                        v-if="teacherList.picture"
                        class="person-img rounded-full"
                        :src="teacherList.picture"
                      />
                      <img
                        v-else
                        class="person-img rounded-full"
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                      {{ teacherList.first_name }}
                      {{ teacherList.last_name }}
                    </template>
                    <template v-slot:option="teacherList">
                      <img
                        v-if="teacherList.picture"
                        class="person-img rounded-full"
                        :src="teacherList.picture"
                      />
                      <img
                        v-else
                        class="person-img rounded-full"
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                      {{ teacherList.first_name }}
                      {{ teacherList.last_name }}
                    </template>
                    <template #list-footer>
                      <li
                        ref="loadTeacher"
                        class="loader"
                        v-show="teacher_meta.has_next"
                      >
                        Loading more staffs...
                      </li>
                    </template>
                  </v-select>
              </div>
      </template>

      <vs-input
        placeholder="Notes Title"
        v-model="createPayload.title"
        class="transparent_input_holder w-full mb-4"
      />

      <div v-if="send_notes_to == '3'" class="mb-4">
        <v-select multiple placeholder="Select Students"> </v-select>
      </div>

      <div>
        <h4
          style="cursor: pointer"
          class="mb-4"
          @click="add_description = !add_description"
        >
          <a class="primary">+ Add Description</a>
        </h4>
      </div>
      <vs-textarea v-model="createPayload.description" v-if="add_description" />
      <editor
        ref="tinyMce"
        v-model="createPayload.body"
        :api-key="tinyMceApi"
        :init="initializeTinyMce"
      />

      <div class="py-4">
        <h4 class="mb-4">Linked Online Resources</h4>
        <vs-button
          type="border"
          icon="add"
          v-if="!addFileModal && filesInfo.length == 0"
          @click="addFileModal = true"
          >Add file</vs-button
        >
        <div v-if="addFileModal">
          <FileUpload
            section_type="Notes"
            :multiplefile="false"
            @getFileIdHeader="getIdFile"
            :file_repository_id="repository_id"
            :filesInfo="filesInfo"
            @deletedIndex="deletedIndex"
            ref="fileUploadRef"
          />
        </div>
      </div>

      <!-- <div class="text-right">
            <div class="btn_select_dropdown_holder">
              <div class="each_btn_holder">
                <span>{{ selectedBtnOption.title }}</span>
              </div>
              <div class="downarrow" @click="cstmBtnDrop = !cstmBtnDrop">
                <span class="material-icons-outlined">arrow_drop_down</span>
              </div>
              <div class="cstm_dropdown" :class="[cstmBtnDrop ? 'show' : '']">
                <span v-for="(btn, index) in btn_options" :key="index">
                  <p class="each_opt" @click="btnOption(index)">{{ btn.title }}</p>
                </span>
              </div>
            </div>
          </div> -->
      <div class="text-right">
        <vs-button type="flat" class="mr-1" @click="createNote(false)"
          >Save</vs-button
        >
        <vs-button @click="createNote(true)">Save & Submit</vs-button>
      </div>
    </div>
    <!-- <div style="padding: 15px 30px;">
          <h4 class="mb-4">Email Notes</h4>
          <vs-row>
            <vs-col vs-lg="8" vs-sm="12">
              <vs-checkbox class="mb-4" value="parents" v-model="email_notes">
                Parents
              </vs-checkbox>
              <vs-checkbox class="mb-4" value="students" v-model="email_notes">
                Students
              </vs-checkbox>
              <vs-checkbox class="mb-4" value="myself" v-model="email_notes">
                Myself
              </vs-checkbox>
              <vs-checkbox value="admin" v-model="email_notes">
                Admin
              </vs-checkbox>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" vs-type="flex" vs-align="flex-end" vs-justify="flex-end">
              <vs-button>Send</vs-button>
            </vs-col>
          </vs-row>
        </div> -->
    <div style="padding: 15px 30px">
      <vs-collapse>
        <vs-collapse-item
          class="light_blue_holder mb-2"
          v-for="(note, noteIndex) in noteList"
          :key="noteIndex"
        >
          <div class="header" slot="header">
            <div>
              <h6>{{ note.title }}</h6>
              <small
                >{{ note.createdBy.first_name }}
                {{ note.createdBy.last_name }}</small
              >
            </div>
            <div class="inline-flex">
              <vs-dropdown
              style="margin-left: 5px; cursor: pointer"
              vs-custom-content
              
            >
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-more-vertical"
            ></vs-button>

              <vs-dropdown-menu style="min-width: 100px" class="modal_dropdown_menu">
                <vs-dropdown-item
                @click.stop="notesDownload(note.id)"
                  >Download</vs-dropdown-item
                >
                <vs-dropdown-item
                @click.stop="pdfPreview(note.id)"
                  >Print</vs-dropdown-item
                >
                <!-- <vs-dropdown-item
                @click.stop="editNote(note)"
                  >Edit</vs-dropdown-item
                >
                <vs-dropdown-item
                @click.stop="pdfPreview(note)"
                  >Delete</vs-dropdown-item
                > -->
              
              </vs-dropdown-menu>
            </vs-dropdown>
            </div>
          </div>
          <div v-html="note.body"></div>
          <div v-if="note.file.length > 0">
              <div
                v-for="(file, index) in note.file"
                :key="index"
                style="background: #e6f5f6;
                 border-radius: 10px;
                  padding: 25px 12px;
                  margin: 10px 0;
                "
              >
                  <!-- <img :src="file.file_path" alt=""> -->
                  <i
                    v-if="file.file_type.includes('pdf')"
                    class="material-icons"
                    style="color: teal"
                    >picture_as_pdf</i
                  >
                  <div v-else-if="video_array.includes(file.file_type)">
                    <video width="100%" height="500px" controls :src="file.file_path"></video>
                  </div>
                  
                  <img
                    v-else-if="image_array.includes(file.file_type)"
                    :src="file.file_path"
                    style="max-width: 100%"
                  />

                  <div v-else-if="audio_array.includes(file.file_type)">
                    <audio class="w-full" controls :src="file.file_path" :type="file.file_type" >
                  </audio>
                  </div>
                
                  <div  v-else-if="
                      file.file_type.includes('doc') ||
                      file.file_type.includes('docx')
                    "  class="flex flex-wrap items-center">
                   <svg
                   
                   xmlns="http://www.w3.org/2000/svg"
                   x="0px"
                   y="0px"
                   width="40"
                   height="40"
                   viewBox="0 0 172 172"
                   style="fill: #000000"
                 >
                   <g
                     fill="none"
                     fill-rule="nonzero"
                     stroke="none"
                     stroke-width="1"
                     stroke-linecap="butt"
                     stroke-linejoin="miter"
                     stroke-miterlimit="10"
                     stroke-dasharray=""
                     stroke-dashoffset="0"
                     font-family="none"
                     font-weight="none"
                     font-size="none"
                     text-anchor="none"
                     style="mix-blend-mode: normal"
                   >
                     <path d="M0,172v-172h172v172z" fill="none"></path>
                     <g fill="#9b59b6">
                       <path
                         d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"
                       ></path>
                     </g>
                   </g>
                 </svg>
                 <b>{{file.file_name}}</b>
                  </div>
                  <div v-else class="flex flex-wrap items-center">
                    <span  class="material-icons-outlined">
                    description
                  </span>
                  <b>{{file.file_name}}</b>
                  </div>
                  
              </div>
            </div>
        </vs-collapse-item>
      </vs-collapse>
    </div>
    <div v-if="pdfPreviewModal">
      <PdfPreviewModalComponent
        :pdfPreviewModal="pdfPreviewModal"
        :pdfDetails="pdfDetails"
        @pdfPreviewModalClose="pdfPreviewModalClose"
      />
    </div>
  </div>
</template>
<script>
import { calenderCreateNote, calenderNoteList } from '@/api/calenderAction.js'
import { notesDownload } from '@/api/lesson_notes.js'
import PdfPreviewModalComponent from '@/views/pages/v1/schedule/components/pdfPreview.vue'

import vSelect from 'vue-select'

import FileUpload from '@/views/pages/v1/notes/components/Template/NotesFileComponent.vue'
import axios from 'axios'
import { repository } from '@/mixins/repository.js'
import Editor from '@tinymce/tinymce-vue'
import { fetchUserClient } from '@/api/task-project.js'
export default {
  mixins: [repository],
  components: {
    editor: Editor,
    FileUpload,
    axios,
    PdfPreviewModalComponent,
    vSelect
  },
  props: {
    schedule_id: {
      default: 0
    },
    course_id: {
      default: 0
    }
  },
  data () {
    return {
      video_array:['mpeg', 'mp4', 'mpg', 'mpe', 'qt', 'mov', 'mxu', 'm4u', 'flv', 'asf', 'asx', 'wmv', 'wm', 'wmx', 'avi', 'ogv', 'movie'],
      audio_array:['au', 'snd', 'mid', 'midi', 'kar', 'mpga', 'mp2', 'mp3', 'aif', 'aiff', 'aifc', 'm3u', 'wma', 'wax', 'ram', 'ra', 'wav'],
      image_array:['bmp', 'cgm', 'gif', 'ief', 'jpeg', 'jpg', 'jpe', 'png', 'svg', 'tiff', 'tif', 'djvu', 'djv', 'wbmp', 'ras', 'ico', 'pnm', 'pbm', 'pgm', 'ppm', 'rgb', 'xbm', 'psd', 'xpm', 'xwd'],
      studentsChecked:false,
      staffChecked: false,
      parentsChecked: false,
      pdfDetails: null,
      customer_id: localStorage.getItem('customer_id'),
      pdfPreviewModal: false,
      studentlist: [],
      noteList: [],
      teacherList: [],
      parentlist: [],
      selectedStudent: [],
      selectedParent: [],
      selectedStaff: [],
      student_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      parent_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      observerStudent: new IntersectionObserver(this.loadMorestudents),
      observerParents: new IntersectionObserver(this.loadMoreParent),
      observerTeacher: new IntersectionObserver(this.loadMoreStaff),
      add_description: false,
      send_notes_to: '1',
      studentDropdown: false,
      parentDropdown: false,
      staffDropdown: false,
      filesInfo: [],
      addFileModal: false,
      createPayload: {
        schedule_id: null,
        course_id: null,
        title: '',
        description: '',
        body: '',
        has_all_subject: true,
        save_type: false,
        originated_from: 'CALENDER_ACTIONS',
        is_private: false,
        files: []
      },
      tinyMceApi: '',
      initializeTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )

          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            classes: 'myClass',

            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            // text: 'Gdrive',
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor |         table alignleft aligncenter alignright alignjustify |         bullist numlist outdent indent | removeformat | help'
      }
    }
  },
  methods: {
    deletedIndex (deleteIndex) {
      this.filesInfo.splice(deleteIndex, 1)
      this.createPayload.files = []
    },
    getIdFile (obj) {
      console.log(obj)
      this.createPayload.files.push(obj)
    },
    async addToSelectAllParent () {
      if (this.selectedParent.length === this.parentlist.length) {
        this.selectedParent = []
      } else {
        this.selectedParent = this.parentlist
      }
    },
    async addToSelectAllTeacher () {
      if (this.selectedStaff.length === this.teacherList.length) {
        this.selectedStaff = []
      } else {
        this.selectedStaff = this.teacherList
      }
    },
    outsideDropdownStudent () {
      this.studentDropdown = false
    },
    outsideDropdownParent () {
      this.parentDropdown = false
    },
    outsideDropdownStaff () {
      this.staffDropdown = false
    },
    async addToSelectAllStudent () {
      if (this.selectedStudent.length === this.studentlist.length) {
        this.selectedStudent = []
      } else {
        this.selectedStudent = this.studentlist
      }
      console.log(this.selectedStudent)
    },
    pdfPreviewModalClose () {
      this.pdfPreviewModal = false
    },
    async pdfPreview (id) {
      const { data } = await notesDownload(this.customer_id, id)


      this.openInNewTab(data.data.url)
      
      // this.pdfDetails = noteDetails
      // this.pdfPreviewModal = true
    },
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href
      }).click()
    },
    async notesDownload (id) {
      const { data } = await notesDownload(this.customer_id, id)
      this.downloadItem({
        url: data.data.url,
        label: data.data.name
      })
      this.showSuccessMessage(
        'Success',
        'Notes downloaded successfully',
        'success'
      )
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'mime' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    async fetchCalenderNoteList () {
      const payload = {
        schedule_id: this.schedule_id
      }
      const { data } = await calenderNoteList(payload, this.customer_id)
      this.noteList = data.data.note
    },
    async createNote (save_type) {
      // 1-->teachers, 2->parent, 3->student
      const Studentreceivers = this.selectedStudent.map((ele) => {
        return {
          receiver_id: ele.client_users_id,
          receiver_type: 3
        }
      })
      const parentreceivers = this.selectedParent.map((ele) => {
        return {
          receiver_id: ele.client_users_id,
          receiver_type: 2
        }
      })
      const Staffreceivers = this.selectedStaff.map((ele) => {
        return {
          receiver_id: ele.users_id,
          receiver_type: 1
        }
      })

      const payload = {
        ...this.createPayload,
        save_type,
        courses: [this.course_id],
        schedule_id: this.schedule_id,
        receivers: [...Studentreceivers, ...Staffreceivers, ...parentreceivers]
      }
      await calenderCreateNote(payload, this.customer_id)

      this.showSuccessMessage(
        'Success',
        'Note Assigned Successfully',
        'success'
      )
      this.createPayload = {
        schedule_id: null,
        course_id: null,
        title: '',
        description: '',
        body: '',
        has_all_subject: true,
        save_type: false,
        originated_from: 'CALENDER_ACTIONS',
        is_private: false,
        files: []
      }
      this.filesInfo = []
      this.fetchCalenderNoteList()
    },
    checkStudent (user_id) {
      const check = this.selectedStudent.findIndex(
        (ele) => ele.client_users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    checkParent (user_id) {
      const check = this.selectedParent.findIndex(
        (ele) => ele.client_users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    checkStaff (user_id) {
      const check = this.selectedStaff.findIndex(
        (ele) => ele.users_id === user_id
      )
      if (check === -1) {
        return false
      } else {
        return true
      }
    },
    async addToSelectStudent (student) {
      const check = this.selectedStudent.findIndex(
        (ele) => ele.client_users_id === student.client_users_id
      )
      if (check === -1) {
        this.selectedStudent.push(student)
      } else {
        this.selectedStudent = this.selectedStudent.filter(
          (ele) => ele.client_users_id !== student.client_users_id
        )
      }
    },
    async addToSelectParent (parent) {
      const check = this.selectedParent.findIndex(
        (ele) => ele.client_users_id === parent.client_users_id
      )
      if (check === -1) {
        this.selectedParent.push(parent)
      } else {
        this.selectedParent = this.selectedParent.filter(
          (ele) => ele.client_users_id !== parent.client_users_id
        )
      }
    },
    async addToSelectStaff (staff) {
      const check = this.selectedStaff.findIndex(
        (ele) => ele.users_id === staff.users_id
      )
      if (check === -1) {
        this.selectedStaff.push(staff)
      } else {
        this.selectedStaff = this.selectedStaff.filter(
          (ele) => ele.users_id !== staff.users_id
        )
      }
    },
    async onOpenStudent () {
      if (this.student_meta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    async onOpenParent () {
      if (this.parent_meta.has_next) {
        await this.$nextTick()
        this.observerParents.observe(this.$refs.loadParent)
      }
    },
    onCloseParent () {
      this.observerParents.disconnect()
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async loadMoreParent () {
      try {
        const payload = {
          type: ['parent']
        }
        this.parent_meta.page = this.parent_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist.push(...data.data.data.users_list)
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async loadMoreStaff () {
      try {
        this.teacher_meta.page = this.teacher_meta.page + 1

        const data = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta
        )
        this.teacherList.push(...data.data.data.users_list)
        this.teacher_meta = data.data.data.meta
        this.teacher_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async loadMorestudents () {
      try {
        const payload = {
          type: ['children', 'individual']
        }
        this.student_meta.page = this.student_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist.push(...data.data.data.users_list)
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async getTeacherList () {
      try {
        const payload = {}

        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async fetchStudentList () {
      try {
        const payload = {
          type: ['children', 'individual']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async fetchParentList () {
      try {
        const payload = {
          type: ['parent']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist = data.data.data.users_list
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted () {
    this.fetchCalenderNoteList()
    this.fetchStudentList()
    this.fetchParentList()
    this.getTeacherList()
    this.getRepositoryId(54)
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}
</script>